<div class="pp-empty">
  <i *ngIf="icon" [class]="icon"></i>
  <p>{{ message }}</p>
</div>
